import React, { useEffect, useState } from 'react';
import { ArticleList, CardSection, CardTitle } from './styled';
import { useRouter } from 'next/router';
import { getSimilarData } from '../../../Utils/helper';
import Image from 'next/image';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import {
  fireClickedCardEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default function RelatedArticlesNew(props) {
  const { pageType, similarElements } = props;
  const router = useRouter();
  let articles = getSimilarData(similarElements, 'article');
  const [cardEffect, setCardEffect] = useState({ index: null, effect: '' });
  useEffect(() => {
    if (articles?.length > 0) {
      let cardId = [];
      articles.forEach((element) => {
        cardId.push(element.id);
      });
      fireServedSectionEvent('related Articles', cardId, pageType);
    }
  }, [articles]);

  return (
    <>
      {articles?.length > 0 ? (
        <CardSection>
          <CardTitle as="h2">Related Articles</CardTitle>
          <ArticleList>
            {articles?.map((element, index) => {
              const imageUrl = element.image_url;
              const web_url = element?.web_url;
              return (
                <AnchorCoverTag
                  url={web_url}
                  key={`related_article${index}`}
                  cardEffect={
                    index === cardEffect.index ? cardEffect.effect : ''
                  }
                >
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      setCardEffect({
                        index: index,
                        effect: 'lowOpacity',
                      });
                      setTimeout(() => {
                        router.push(web_url + getSearchParams(), '', {
                          locale: getRouterLocale(router),
                        });
                      }, [200]);
                    }}
                  >
                    <li
                      onClick={() =>
                        fireClickedCardEvent(
                          'related Articles',
                          element.title,
                          pageType,
                          element.id,
                        )
                      }
                    >
                      {imageUrl ? (
                        <Image
                          src={imageUrl}
                          alt={`Images related to ${element?.title}`}
                          loading="lazy"
                          quality={90}
                          height={64}
                          width={64}
                          sizes="50vw"
                        />
                      ) : null}

                      <h3>{element?.title}</h3>
                    </li>
                  </a>
                </AnchorCoverTag>
              );
            })}
          </ArticleList>
        </CardSection>
      ) : null}
    </>
  );
}
